import { render } from "./design.vue?vue&type=template&id=23345048"
import script from "./design.vue?vue&type=script&lang=js"
export * from "./design.vue?vue&type=script&lang=js"

import "./design.vue?vue&type=style&index=0&id=23345048&lang=less"

import exportComponent from "/Users/alex/Documents/Google Ads/Panorama Residence/Panorama web/panorama-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__